function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 48L21.7735 38H10.2265L16 48ZM17 43.5918V38.6939H15L15 43.5918H17ZM17 36.7347L17 31.8367H15V36.7347H17ZM17 29.8776V24.9796H15L15 29.8776H17ZM17 23.0204V18.1224H15V23.0204H17ZM17 16.1633V11.2653H15L15 16.1633H17ZM17 9.30612L17 4.40816H15V9.30612H17ZM17 2.44898V0H15V2.44898H17Z",
  fill: "#4B5563"
});
function SvgEstimatedArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 48,
    viewBox: "0 0 32 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstimatedArrowIcon);
export default __webpack_public_path__ + "static/media/estimatedArrowIcon.45237720259406d4b0edd60568767917.svg";
export { ForwardRef as ReactComponent };